import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { CIC_FEE_REASONS_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const cicFeeReasonsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case CIC_FEE_REASONS_ACTION_TYPE.GET_FEE_REASONS:
        return payload || initialState;

      case CIC_FEE_REASONS_ACTION_TYPE.CREATE_FEE_REASON:
      case CIC_FEE_REASONS_ACTION_TYPE.EDIT_FEE_REASON:
        draft[payload.cicFeeReasonId] = payload;
        break;

      case CIC_FEE_REASONS_ACTION_TYPE.DELETE_FEE_REASON:
        delete draft[meta.cicFeeReasonId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default cicFeeReasonsReducer;
